/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioCategory } from './InternalApiScenarioCategory';
import {
    InternalApiScenarioCategoryFromJSON,
    InternalApiScenarioCategoryFromJSONTyped,
    InternalApiScenarioCategoryToJSON,
    InternalApiScenarioCategoryToJSONTyped,
} from './InternalApiScenarioCategory';
import type { InternalApiScenarioStatus } from './InternalApiScenarioStatus';
import {
    InternalApiScenarioStatusFromJSON,
    InternalApiScenarioStatusFromJSONTyped,
    InternalApiScenarioStatusToJSON,
    InternalApiScenarioStatusToJSONTyped,
} from './InternalApiScenarioStatus';
import type { InternalApiScenarioTypeV2 } from './InternalApiScenarioTypeV2';
import {
    InternalApiScenarioTypeV2FromJSON,
    InternalApiScenarioTypeV2FromJSONTyped,
    InternalApiScenarioTypeV2ToJSON,
    InternalApiScenarioTypeV2ToJSONTyped,
} from './InternalApiScenarioTypeV2';
import type { InternalApiScenarioTypology } from './InternalApiScenarioTypology';
import {
    InternalApiScenarioTypologyFromJSON,
    InternalApiScenarioTypologyFromJSONTyped,
    InternalApiScenarioTypologyToJSON,
    InternalApiScenarioTypologyToJSONTyped,
} from './InternalApiScenarioTypology';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';
import type { InternalApiScenarioEntityType } from './InternalApiScenarioEntityType';
import {
    InternalApiScenarioEntityTypeFromJSON,
    InternalApiScenarioEntityTypeFromJSONTyped,
    InternalApiScenarioEntityTypeToJSON,
    InternalApiScenarioEntityTypeToJSONTyped,
} from './InternalApiScenarioEntityType';

/**
 * 
 * @export
 * @interface InternalApiScenarioBasicDetails
 */
export interface InternalApiScenarioBasicDetails {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioBasicDetails
     */
    id: string;
    /**
     * 
     * @type {InternalApiScenarioEntityType}
     * @memberof InternalApiScenarioBasicDetails
     */
    entityType: InternalApiScenarioEntityType;
    /**
     * 
     * @type {InternalApiScenarioTypeV2}
     * @memberof InternalApiScenarioBasicDetails
     */
    type: InternalApiScenarioTypeV2;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioBasicDetails
     */
    name: string;
    /**
     * 
     * @type {InternalApiScenarioStatus}
     * @memberof InternalApiScenarioBasicDetails
     */
    status: InternalApiScenarioStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioBasicDetails
     */
    libraryScenarioHandle?: string;
    /**
     * 
     * @type {InternalApiScenarioCategory}
     * @memberof InternalApiScenarioBasicDetails
     */
    category?: InternalApiScenarioCategory;
    /**
     * 
     * @type {InternalApiScenarioTypology}
     * @memberof InternalApiScenarioBasicDetails
     */
    typology?: InternalApiScenarioTypology;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioBasicDetails
     */
    internalId?: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioBasicDetails
     */
    updatedTime: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioBasicDetails
     */
    currentVersionLogic?: string;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiScenarioBasicDetails
     */
    currentVersionParameters?: Array<InternalApiScenarioVersionParameter>;
}



/**
 * Check if a given object implements the InternalApiScenarioBasicDetails interface.
 */
export function instanceOfInternalApiScenarioBasicDetails(value: object): value is InternalApiScenarioBasicDetails {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    return true;
}

export function InternalApiScenarioBasicDetailsFromJSON(json: any): InternalApiScenarioBasicDetails {
    return InternalApiScenarioBasicDetailsFromJSONTyped(json, false);
}

export function InternalApiScenarioBasicDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioBasicDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityType': InternalApiScenarioEntityTypeFromJSON(json['entityType']),
        'type': InternalApiScenarioTypeV2FromJSON(json['type']),
        'name': json['name'],
        'status': InternalApiScenarioStatusFromJSON(json['status']),
        'libraryScenarioHandle': json['libraryScenarioHandle'] == null ? undefined : json['libraryScenarioHandle'],
        'category': json['category'] == null ? undefined : InternalApiScenarioCategoryFromJSON(json['category']),
        'typology': json['typology'] == null ? undefined : InternalApiScenarioTypologyFromJSON(json['typology']),
        'internalId': json['internalId'] == null ? undefined : json['internalId'],
        'updatedTime': (new Date(json['updatedTime'])),
        'currentVersionLogic': json['currentVersionLogic'] == null ? undefined : json['currentVersionLogic'],
        'currentVersionParameters': json['currentVersionParameters'] == null ? undefined : ((json['currentVersionParameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
    };
}

export function InternalApiScenarioBasicDetailsToJSON(json: any): InternalApiScenarioBasicDetails {
    return InternalApiScenarioBasicDetailsToJSONTyped(json, false);
}

export function InternalApiScenarioBasicDetailsToJSONTyped(value?: InternalApiScenarioBasicDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': InternalApiScenarioEntityTypeToJSON(value['entityType']),
        'type': InternalApiScenarioTypeV2ToJSON(value['type']),
        'name': value['name'],
        'status': InternalApiScenarioStatusToJSON(value['status']),
        'libraryScenarioHandle': value['libraryScenarioHandle'],
        'category': InternalApiScenarioCategoryToJSON(value['category']),
        'typology': InternalApiScenarioTypologyToJSON(value['typology']),
        'internalId': value['internalId'],
        'updatedTime': value['updatedTime'].toISOString(),
        'currentVersionLogic': value['currentVersionLogic'],
        'currentVersionParameters': value['currentVersionParameters'] == null ? undefined : ((value['currentVersionParameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
    };
}

